module.exports = __webpack_public_path__ + "static/media/flexible-spending.3989eb75.svg";